export default __webpack_public_path__ + "static/media/art-pro-brw-banner-3.7eba0920.jpg";